export function corregirTextoAUTF8(textoMalCodificado) {
  try {
    const regex = /[áéíóúÁÉÍÓÚñÑ]/;
    if (regex.test(textoMalCodificado)) {
      // Si el texto ya está bien codificado, no es necesario corregirlo.
      return textoMalCodificado;
    }
    // Paso 1: Obtener los "bytes" originales.
    // La cadena mal codificada tiene caracteres cuyos códigos de carácter (charCodeAt)
    // representan los bytes individuales de la secuencia UTF-8 original.
    // Por ejemplo, 'Ã' (código 195) era el byte 0xC3, y 'º' (código 186) era el byte 0xBA.
    // Juntos, 0xC3 0xBA forman 'ú' en UTF-8.
    const bytes = new Uint8Array(textoMalCodificado.length);
    for (let i = 0; i < textoMalCodificado.length; i++) {
      bytes[i] = textoMalCodificado.charCodeAt(i) & 0xff; // Tomar el byte inferior
    }

    // Paso 2: Decodificar esa secuencia de bytes como UTF-8.
    // TextDecoder interpreta la secuencia de bytes como si fuera UTF-8.
    const decoder = new TextDecoder('utf-8');
    const textoCorregido = decoder.decode(bytes);
    return textoCorregido;
  } catch (error) {
    console.error('Error durante la corrección de la codificación:', error);
    // Como fallback, se puede intentar la combinación decodeURIComponent(escape()),
    // aunque el método con TextDecoder es generalmente más preciso para este caso.
    try {
      return decodeURIComponent(escape(textoMalCodificado));
    } catch (e2) {
      console.error('Error con decodeURIComponent(escape()):', e2);
      // Si ambos métodos fallan, devuelve el texto original.
      return textoMalCodificado;
    }
  }
}
